import { createIcon } from '@chakra-ui/icons';

export const MusicIcon = createIcon({
  displayName: 'MusicIcon',
  viewBox: '0 0 25 29',
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.334 2.968V21.17c-.001.891-.305 1.76-.87 2.479a4.501 4.501 0 01-2.27 1.522c-.91.27-1.888.262-2.794-.022a4.487 4.487 0 01-2.241-1.557 4.008 4.008 0 01-.825-2.493 4.024 4.024 0 01.91-2.466 4.515 4.515 0 012.296-1.489 4.805 4.805 0 012.794.063V5.768h-12V23.97c-.001.891-.305 1.76-.87 2.479a4.502 4.502 0 01-2.27 1.522c-.91.27-1.888.262-2.794-.022a4.488 4.488 0 01-2.241-1.557 4.008 4.008 0 01-.825-2.493 4.024 4.024 0 01.91-2.466 4.515 4.515 0 012.296-1.488 4.805 4.805 0 012.793.063V2.968c0-.742.317-1.455.88-1.98a3.112 3.112 0 012.12-.82h12c.796 0 1.56.295 2.122.82a2.71 2.71 0 01.879 1.98z"
      clipRule="evenodd"
    />
  ),
});
